import { useEffect, useState } from "react";
import TabBox from "../../Components/Tabbox/TabBox";
import UserInsTable from "../../Tables/DeltaHedgeExe/UserInsTable";
import { IDeltaHedgeExeCommonSearchParam } from "../../Interfaces/deltaHedgeExe";
import InsTable from "../../Tables/DeltaHedgeExe/InsTable";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { getBaseInstruments } from "../../Requests/Order/tradeTableRequests";
import DeltaTable from "../../Tables/DeltaHedgeExe/DeltaTable";
import DetailProcessTable from "../../Tables/DeltaHedgeExe/DetailProcess/DetailProcessTable";
import ErrorTable from "../../Tables/DeltaHedgeExe/ErrorTable";
import UsersMultiSelectDropdown from "../../Components/Dropdown/Users/UsersMultiSelectDropdown";
import DeltaHedgeExeIncremental from "../../Tables/DeltaHedgeExe/Incremental/Incremental";
import DeltaHedgeExeDecremental from "../../Tables/DeltaHedgeExe/Decremental/Decremental";
import { useSearchParams } from "react-router-dom";
import { useErrorTabCount } from "src/Hooks/useErrorTabCount";
import { getErrorTable } from "../../Requests/deltaHedgeExe";

enum ActiveTab {
  Management,
  InsManagement,
  Process,
  Delta,
  Error,
  Incremental,
  Decremental,
}

const DeltaHedgeExe = () => {
  const [searchParams, setSearchParams] = useState(
    {} as IDeltaHedgeExeCommonSearchParam
  );
  const [querySearchParams, setQuerySearchParams] = useSearchParams();

  const activeTab = parseInt(querySearchParams.get("tab") || "-1");

  const { errorTabCount, errorTableRefreshFlag, errorTableAfterFetchHandler } =
    useErrorTabCount("deltaHedgeExe", activeTab, ActiveTab.Error, getErrorTable);

  // const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.Management);

  useEffect(() => {
    const searchParams = new URLSearchParams(querySearchParams);
    searchParams.set(
      "tab",
      querySearchParams.get("tab") || ActiveTab.Management.toString()
    );
    setQuerySearchParams(searchParams);
  }, []);

  const tabChildren = [
    { index: ActiveTab.Management, title: "مدیریت" },
    { index: ActiveTab.InsManagement, title: "مدیریت سهم" },
    { index: ActiveTab.Process, title: "فرایند" },
    { index: ActiveTab.Delta, title: "دلتا" },
    { index: ActiveTab.Incremental, title: "تعدیل افزایشی" },
    { index: ActiveTab.Decremental, title: "تعدیل کاهشی" },
    { index: ActiveTab.Error, title: "خطا", count: errorTabCount },
  ];

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  const getTable = () => {
    switch (parseInt(querySearchParams.get("tab") || "-1")) {
      case ActiveTab.Delta:
        return <DeltaTable searchParams={searchParams} />;

      case ActiveTab.Process:
        return <DetailProcessTable searchParams={searchParams} />;

      case ActiveTab.Error:
        return (
          <ErrorTable
            searchParams={searchParams}
            onFetchComplete={errorTableAfterFetchHandler}
            refreshFlag={errorTableRefreshFlag}
          />
        );

      case ActiveTab.Management:
        return <UserInsTable searchParams={searchParams} />;

      case ActiveTab.InsManagement:
        return <InsTable searchParams={{ ins: searchParams.ins }} />;

      case ActiveTab.Incremental:
        return <DeltaHedgeExeIncremental searchParams={searchParams} />;

      case ActiveTab.Decremental:
        return <DeltaHedgeExeDecremental searchParams={searchParams} />;

      default:
        return <></>;
    }
  };

  const tabChangeHandler = (indexStr: string) => {
    const searchParams = new URLSearchParams(querySearchParams);
    searchParams.set("tab", indexStr);
    setQuerySearchParams(searchParams);
  };

  return (
    <div className="flex flex-col justify-start items-start gap-8 px-5 mx-auto relative">
      <div className="flex flex-row justify-start items-start gap-3">
        <div className="w-40">
          <UsersMultiSelectDropdown
            label="کاربر"
            name="user"
            onChange={changeHandler}
            value={searchParams.user}
          />
        </div>
        <div className="w-40">
          <DynamicDropdown
            dropdown={{
              name: "ins",
              placeholder: "نماد",
            }}
            onChange={changeHandler}
            value={searchParams.ins}
            getData={() => getBaseInstruments()}
          />
        </div>
      </div>

      <div className="w-min">
        <TabBox
          activeTab={parseInt(querySearchParams.get("tab") || "-1")}
          onChange={(_, index) => tabChangeHandler(index.toString())}
          children={tabChildren}
        />
      </div>
      {getTable()}
    </div>
  );
};

export default DeltaHedgeExe;
